import { ConfirmModal } from './ConfirmModal';
import { useDeleteUser } from '../hooks';

interface Props {
  open: boolean;
  userId: string;
  userName?: string;
  onClose: () => void;
  onSuccess?: () => void;
}

export function DeleteUserModal({ open, userId, userName, onClose, onSuccess }: Props) {
  const mutation = useDeleteUser();
  return (
    <ConfirmModal
      open={open}
      title={`Delete ${userName ?? 'user'}?`}
      description="The account is soft-deleted. Audit logs and payment history are preserved."
      confirmLabel="Delete"
      destructive
      loading={mutation.isPending}
      onClose={onClose}
      onConfirm={async () => {
        await mutation.mutateAsync(userId);
        onSuccess?.();
        onClose();
      }}
    >
      {mutation.error && (
        <p className="text-xs text-red-300">{(mutation.error as Error).message}</p>
      )}
    </ConfirmModal>
  );
}
